import React from 'react';
import {
  DateTimeField,
  List,
  useListContextRequired,
  useShowContextRequired,
  Cell,
  usePopupManager,
  TextLink,
} from 'ui-builder';
import { MARKET_REQUESTS_UPDATED, MarketRequest, useMarketRequestsService } from 'nekst-api';
import { GridLayout, InformationMessage } from 'features/nekst-widgets';
import RequestInfoPopup from './RequestInfoPopup';
import RequestStatusField from './RequestStatusField';
import { OpenChatLink } from '../../../thirdpartyscripts/crisp/CrispChat';
import { AllTeamSetupAreasContext } from '../TeamSetupAreaContext';

function UpdateRequestMessage() {
  const { data } = useListContextRequired();


  if (data?.length) {
    return (
      <InformationMessage>
        To make changes to any request or to provide information,
        {' '}
        <OpenChatLink>please contact our support team</OpenChatLink>.
      </InformationMessage>
    );
  } else {
    return null;
  }
}

function RequestLink() {
  const popupManager = usePopupManager();

  const { data } = useShowContextRequired<MarketRequest>();

  return (
    <TextLink
      onClick={() => {
        popupManager.openPopup(<RequestInfoPopup data={data} />);
      }}
    >
      {data.name}
    </TextLink>
  );
}

export default function MarketRequestsList() {
  const marketRequestsService = useMarketRequestsService();

  return (
    <AllTeamSetupAreasContext>
      <List
        getDataFunc={marketRequestsService.getMarketRequests}
        updateOnEvents={[MARKET_REQUESTS_UPDATED]}
      >
        <UpdateRequestMessage />
        <GridLayout weights={[3, 4, 2, 2]} noDataMessage="No market requests found">
          <Cell label="Title">
            <RequestLink />
          </Cell>
          <Cell label="Status">
            <RequestStatusField />
          </Cell>
          <DateTimeField label="Created" source="createdAt" />
        </GridLayout>
      </List>
    </AllTeamSetupAreasContext>

  );
}
